import { gql } from "@apollo/client/core";

const EVENT_POLICY_FIELDS = gql`
  fragment PoliciesEventPolicyFields on EventPolicy {
    policyId
    orgId
    name
    versionTag
    rules
    status
    createdAt
    updatedAt
  }
`;

const SUCCESS_RESPONSE_FIELDS = gql`
  fragment PoliciesSuccessResponseFields on SuccessResponse {
    success
    message
  }
`;

export const LIST_EVENT_POLICIES = gql`
  query PoliciesListEventPolicies($orgId: String!, $q: String) {
    listEventPolicies(orgId: $orgId, q: $q) {
      ...PoliciesEventPolicyFields
    }
  }
  ${EVENT_POLICY_FIELDS}
`;

export const GET_EVENT_POLICY = gql`
  query PoliciesGetEventPolicy($policyId: ID!) {
    getEventPolicy(policyId: $policyId) {
      ...PoliciesEventPolicyFields
    }
  }
  ${EVENT_POLICY_FIELDS}
`;

export const GET_EVENT_ATTACHED_POLICY = gql`
  query PoliciesGetEventAttachedPolicy($eventId: ID!) {
    getEventAttachedPolicy(eventId: $eventId) {
      ...PoliciesEventPolicyFields
    }
  }
  ${EVENT_POLICY_FIELDS}
`;

export const CREATE_EVENT_POLICY = gql`
  mutation PoliciesCreateEventPolicy($input: CreateEventPolicyInput!) {
    createEventPolicy(input: $input) {
      ...PoliciesEventPolicyFields
    }
  }
  ${EVENT_POLICY_FIELDS}
`;

export const PUBLISH_EVENT_POLICY = gql`
  mutation PoliciesPublishEventPolicy($policyId: ID!) {
    publishEventPolicy(policyId: $policyId) {
      ...PoliciesEventPolicyFields
    }
  }
  ${EVENT_POLICY_FIELDS}
`;

export const ATTACH_POLICY_TO_EVENT = gql`
  mutation PoliciesAttachPolicyToEvent($eventId: ID!, $policyId: ID!) {
    attachPolicyToEvent(eventId: $eventId, policyId: $policyId) {
      ...PoliciesSuccessResponseFields
    }
  }
  ${SUCCESS_RESPONSE_FIELDS}
`;

export const GET_EVENT_AIR_CONTRACTS = gql`
  query PoliciesGetEventAirContracts($eventId: ID!, $organizationId: String!) {
    getEventAirContracts(eventId: $eventId, organizationId: $organizationId) {
      enabledAirlineCodes
      removedAirlineCodes
      oneWorldAirContractToggles {
        carrierToggles {
          carrierCode
          airlineName
          enabled
          usesDefaultState
          supportsContract
        }
      }
    }
  }
`;

export const INITIALIZE_EVENT_AIR_CONTRACTS = gql`
  mutation PoliciesInitializeEventAirContracts(
    $eventId: ID!
    $organizationId: String!
  ) {
    initializeEventAirContracts(
      eventId: $eventId
      organizationId: $organizationId
    ) {
      eventId
    }
  }
`;

export const UPDATE_POLICY_AIR_OPT_IN = gql`
  mutation PoliciesUpdatePolicyAirOptIn(
    $eventId: ID!
    $policyId: ID!
    $airlineCode: String!
    $enabled: Boolean!
  ) {
    updatePolicyAirOptIn(
      eventId: $eventId
      policyId: $policyId
      airlineCode: $airlineCode
      enabled: $enabled
    ) {
      policyId
      name
      status
      airOptIns
      updatedAt
    }
  }
`;

export const UPDATE_EVENT_AIR_CONTRACTS = gql`
  mutation PoliciesUpdateEventAirContracts(
    $eventId: ID!
    $organizationId: String!
    $enableAirlineCodes: [String!]!
    $removeAirlineCodes: [String!]!
  ) {
    updateEventAirContracts(
      eventId: $eventId
      organizationId: $organizationId
      enableAirlineCodes: $enableAirlineCodes
      removeAirlineCodes: $removeAirlineCodes
    ) {
      enabledAirlineCodes
      removedAirlineCodes
      oneWorldAirContractToggles {
        carrierToggles {
          carrierCode
          airlineName
          enabled
          usesDefaultState
          supportsContract
        }
      }
    }
  }
`;
